import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UserRoleToken } from '@sleed/bizcommerce-api';
import { userRolesApi } from '~/lib/api/client';
import { formToToken, type UserRoleFormValues } from '~/lib/schemas/user-role';

export const userRoleKeys = { all: ['user-roles-page'] as const, list: () => [...userRoleKeys.all, 'list'] as const };

export function useUserRolesList() {
	return useQuery<UserRoleToken[]>({
		queryKey: userRoleKeys.list(),
		queryFn: async () => (await userRolesApi.getAll()).data.items ?? []
	});
}

export function useUserRoleMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: userRoleKeys.list() });
	const create = useMutation({
		mutationFn: async (form: UserRoleFormValues) => (await userRolesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: UserRoleFormValues) => (await userRolesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await userRolesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
